export const PLATFORM_REPORT_ID = 'platform';
